/**
 * Platform Capability Abstraction (ADR-015，ADR-021 後僅 web 端使用).
 *
 * iOS / Android native 端不再經此層 — SwiftUI / Compose 各自直接呼平台 API。
 * Web 端 WebPlatform 為 stub / mock，作為 spec demo 撐畫面用。
 */

export interface NotifyPayload {
  id?: string;
  title: string;
  body: string;
  /** ISO date string for scheduled delivery; if omitted, immediate. */
  scheduleAt?: string;
}

export interface PlatformCapabilities {
  /** In-app banner stub. */
  notify(payload: NotifyPayload): Promise<void>;

  /** Web 端 stub — 實際 OCR / barcode 在 native 端做。 */
  scanBarcode(): Promise<string>;

  /** <input type="file"> mock（returned blob is volatile）。 */
  pickPhoto(): Promise<Blob>;

  /** navigator.share() 或 download anchor fallback。 */
  shareFile(blob: Blob, name: string): Promise<void>;

  readonly platformName: 'web-demo';
}

export class PlatformError extends Error {
  constructor(
    public readonly code:
      | 'unsupported_on_web'
      | 'permission_denied'
      | 'cancelled'
      | 'unknown',
    message: string
  ) {
    super(message);
    this.name = 'PlatformError';
  }
}
